import {
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useEffect, useState } from 'react';

export default function GlobalTableGenerator({
  columns,
  rows,
  TableContainerStyle,
  TableStyle,
  TableHeadStyle,
  TableBodyStyle,
  loading,
  elevation,
  pagination = false,
  searchOption = false,
  searchBy = [],
}) {
  const [search, setSearch] = useState('');
  const [paginationData, setPaginationData] = useState({
    page: 0,
    limit: 10,
  });
  const [TableRows, setTableRows] = useState([]);

  useEffect(() => {
    Boolean(search)
      ? setTableRows(
          rows?.filter((v) => {
            for (let i of searchBy) {
              if (v?.[i]?.toLowerCase()?.includes(search?.toLowerCase())) return true;
            }
            return false;
          }),
        )
      : pagination
        ? setTableRows(
            rows?.slice(
              paginationData?.limit * (paginationData?.page + 1) - paginationData?.limit,
              paginationData?.limit * (paginationData?.page + 1),
            ),
          )
        : setTableRows(rows);
  }, [paginationData, rows, pagination, search, searchBy]);

  return (
    <TableContainer
      component={Paper}
      elevation={elevation ?? 0}
      aria-label="simple table"
      sx={
        TableContainerStyle ?? {
          border: '1px solid #f3f3f3',
          borderRadius: 1,
        }
      }
    >
      {searchOption && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end', // right align
            p: 2,
          }}
        >
          <TextField
            label="Search"
            size="small"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              sx: { borderRadius: 5 },
              endAdornment: (
                <Stack direction="row">
                  {Boolean(search) && (
                    <IconButton onClick={(e) => setSearch('')}>
                      <ClearOutlinedIcon />
                    </IconButton>
                  )}

                  <IconButton>
                    <SearchOutlinedIcon />
                  </IconButton>
                </Stack>
              ),
            }}
          />
        </Box>
      )}
      <Table sx={TableStyle ?? {}}>
        <TableHead sx={TableHeadStyle ?? {}}>
          <TableRow>
            {columns.map(({ headerName, headerAlign, headerRowSpan, headerColSpan, width }, i) => {
              return (
                <TableCell
                  align={headerAlign ?? 'center'}
                  key={`${i}-head`}
                  rowSpan={headerRowSpan ?? 1}
                  colSpan={headerColSpan ?? 1}
                  sx={{
                    ...(width && { minWidth: width, width, maxWidth: width }),
                    overflow: 'hidden',
                  }}
                >
                  {headerName}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody sx={TableBodyStyle ?? {}}>
          {loading ? (
            <TableRow>
              <TableCell align="center" colSpan={columns?.length}>
                {<CircularProgress />}
              </TableCell>
            </TableRow>
          ) : TableRows?.length ? (
            TableRows.map((e, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map(({ field, width, align, colSpan, rowSpan, renderCell }, i) => (
                  <TableCell
                    align={align ?? 'center'}
                    key={`${i}-body`}
                    rowSpan={rowSpan ?? 1}
                    colSpan={colSpan ?? 1}
                    sx={{
                      ...(width && { minWidth: width, width, maxWidth: width }),
                      overflow: 'hidden',
                    }}
                  >
                    {renderCell ? renderCell({ value: e?.[field], row: e }) : e?.[field]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell align="center" colSpan={columns?.length} sx={{ py: 3, color: 'gray', fontWeight: 600 }}>
                No Data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {pagination && (
        <TablePagination
          component={'div'}
          count={rows?.length ?? 0}
          page={paginationData.page}
          rowsPerPage={paginationData.limit}
          onPageChange={(_, page) => {
            console.log({ page });

            setPaginationData((prev) => ({ ...prev, page }));
          }}
          onRowsPerPageChange={(e) => {
            setPaginationData((prev) => ({ ...prev, limit: e.target.value }));
          }}
          rowsPerPageOptions={[
            { value: 10, label: 10 },
            { value: 25, label: 25 },
            { value: 50, label: 50 },
          ]}
        />
      )}
    </TableContainer>
  );
}
